import React, { useState, Fragment } from 'react';
import { PowerSelect } from "./PowerSelect"
import * as pdata from './powers';

const GROUP_CLASS = 'form-group col';
const CONTROL_CLASS = 'form-control form-control-sm';

export const PowerEntry = ({onAdd, onCancel}) => {
    const [data, setData] = useState({});

    function make_change(name) {
        return (e) => {
            let new_data = {...data};
            new_data[name] = e.target.value;
            setData(new_data);
        };
    }

    const cast_time_change = (e) => {
        setData({...data, cast_time: e.target.value, arcanatime: pdata.arcanify(e.target.value).toFixed(2)});
    }

    const arcanatime_change = (e) => {
        setData({...data, cast_time: '', arcanatime: e.target.value});
    }

    const power_selected = (power) => {
        setData({
            name: power.display_name,
            attack_type: power.effect_area.area,
            cast_time: power.activate.cast_time,
            arcanatime: pdata.arcanify(power.activate.cast_time),
            damage: pdata.power_damage(power),
            recharge: power.activate.recharge_time,
            radius: power.effect_area.radius_feet || 0,
            arc: power.effect_area.arc_degrees || 360
        });
    }

    const add_click = (e) => {
        onAdd(data);
    }

    const gen_inputs = (vals) => {
        return (
            <Fragment>
                {vals.map(inp => (
                    <div key={inp.name} className={GROUP_CLASS}>
                        <label htmlFor={inp.name}>{inp.display_name}:</label>
                        <input type="text" id={inp.name} name={inp.name} className={CONTROL_CLASS} value={data[inp.name] || ''} onChange={inp.on_change} />
                    </div>
                ))}
            </Fragment>
        );
    }

    const text_inputs = [
        {name: 'cast_time', display_name: 'Cast Time', on_change: cast_time_change},
        {name: 'arcanatime', display_name: 'Arcanatime', on_change: arcanatime_change},
        {name: 'damage', display_name: 'Damage', on_change: make_change('damage')},
        {name: 'recharge', display_name: 'Recharge', on_change: make_change('recharge')},
        {name: 'radius', display_name: 'Radius', on_change: make_change('radius')},
        {name: 'arc', display_name: 'Arc', on_change: make_change('arc')}
    ];

    return (
        <div>
            <div className="card">
            <div className="card-body pt-0">
            <div className="card-header">Power</div>
            <PowerSelect onChange={power_selected} />
            <h5 className="card-title">Values</h5>
            <div className="form-row">
                <div className={GROUP_CLASS}>
                    <label htmlFor="name">Name:</label>
                    <input type="text" id="name" name="name" className={CONTROL_CLASS} value={data.name || ''} onChange={make_change('name')} />
                </div>
                <div className={GROUP_CLASS}>
                    <label htmlFor="attack_type">Attack Type:</label>
                    <select name="attack_type" id="attack_type" className={CONTROL_CLASS} onChange={make_change('attack_type')}>
                        <option key='1' value=''></option>
                        {pdata.ATTACK_TYPES.map(atk => (
                            <option key={atk.value} value={atk.value} selected={atk.value == data.attack_type ? true : undefined}>{atk.name}</option>
                        ))}
                    </select>
                </div>
            {gen_inputs(text_inputs.slice(0,3))}
            {gen_inputs(text_inputs.slice(3))}
            </div>
            <div>
               <button type="button" className="btn btn-primary" onClick={add_click}>Add</button>
               <button type="button" className="btn btn-secondary" onClick={onCancel}>Cancel</button>
            </div>
            </div>
            </div>
        </div>
    );
}